/**
 * Web'den giriş yapmış kullanıcıya uygulamayı indirmesini söyleyen bant.
 *
 * Bildirimler, kura töreni ve satın alma tam olarak mobil uygulamada çalışır. Davetle
 * tarayıcıdan katılan kişi içeri alınır, ama her ekranda kendi mağazasına yönlendirilir.
 * Uygulamanın içinde (native) ve Play Store'dan açılmış TWA'da gösterilmez.
 * Kapatılırsa yalnız bu oturum boyunca gizlenir; bir sonraki ziyarette yine çıkar.
 * Kurallar: GetAppBanner.test.tsx.
 */
import { useState } from 'react'
import { Capacitor } from '@capacitor/core'
import { detectTrustedWebActivity } from '@/lib/billingPlatform'
import { StoreDownloadButtons } from './StoreDownloadButtons'

export const GET_APP_DISMISS_KEY = 'gv_get_app_banner_dismissed'

function readDismissed(): boolean {
  try {
    return sessionStorage.getItem(GET_APP_DISMISS_KEY) === '1'
  } catch {
    return false
  }
}

type GetAppBannerProps = {
  /** Testte ortam verilir; uygulamada Capacitor ve TWA algısından okunur. */
  isAppShell?: boolean
}

export function GetAppBanner({
  isAppShell = Capacitor.isNativePlatform() || detectTrustedWebActivity(),
}: GetAppBannerProps) {
  const [dismissed, setDismissed] = useState(readDismissed)

  if (isAppShell || dismissed) return null

  const dismiss = () => {
    try {
      sessionStorage.setItem(GET_APP_DISMISS_KEY, '1')
    } catch {
      // Oturum belleği kapalıysa yalnız bu ekranda gizlenir.
    }
    setDismissed(true)
  }

  return (
    <aside
      aria-label="Uygulamayı indir"
      className="relative z-20 mx-4 mt-4 rounded-3xl border border-amber-100 bg-gradient-to-b from-amber-50 to-white p-4 shadow-sm"
    >
      <button
        type="button"
        onClick={dismiss}
        aria-label="Şimdilik gizle"
        className="absolute right-3 top-3 rounded-full px-2 text-lg leading-none text-amber-900/50 hover:text-amber-900"
      >
        ×
      </button>
      <p className="pr-6 text-sm font-bold text-amber-950">
        Günüm Var'ın tam sürümü mobil uygulamada
      </p>
      <p className="mb-3 mt-1 text-xs text-amber-800">
        Ödeme hatırlatmalarını ve kura bildirimlerini kaçırmamak için uygulamayı indir, aynı hesapla
        giriş yap.
      </p>
      <StoreDownloadButtons />
    </aside>
  )
}

export default GetAppBanner
